export { FixedItemSlider } from './fixed-item-slider';
